/**
 * @description - Save creditor group request object
 * @param this - Context object
 * @returns - The constructed request payload
 */
export function SaveCreditorGroup(this: any) {
  return {
    groupName: this.groupName,
    displayName: this.description,
    description: this.description,
    templateGroupId: this.templateGroupId
  };
}

/**
 * @description - Copy creditor group BMD request object
 * @param this - Context object
 * @returns - The constructed request payload
 */
export function CopyCGBMDs(this: any) {
  return {
    sourceCreditorGroupId: this.id,
    targetCreditorGroupId: this.targetCreditorGroupId,
    copytoCreditors: this.copytoCreditors
  };
}
